import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_STEP = 'UPDATE_QR_CODE_LINK_STEP' as const;

export const updateQrCodeLinkStep = (step: string) => ({
  data: { step },
  type: UPDATE_QR_CODE_LINK_STEP,
});

export type UpdateQrCodeLinkStepResponseAction = DataAction<typeof UPDATE_QR_CODE_LINK_STEP, { step: string }>;
